import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";
import { IAppModel } from "@/model";

/**
 * 店铺服务类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class ShopService extends ServiceBase {

    /**
     * 获取店铺
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getShopDetail(): Promise<IHttpResponse> {
        let response = await this.apis.getShopDetail();
        return response;
    }

    /**
     * 新增/修改店铺
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async addOrModify(data: any): Promise<IHttpResponse> {
        let response = await this.apis.addOrModify(
            {data: data}
        );
        return response;
    }

}